var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 185,
    viewBox: "0 0 190 185",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M108.637 135.297L151.67 184.322L189.754 127.265L168.932 128.732C142.297 51.2352 92.9783 9.61058 0.0789519 0.69082C109.388 41.4408 132.314 133.334 130.211 133.778C128.107 134.222 108.637 135.297 108.637 135.297Z",
    fill: "url(#paint0_linear_3480_18884)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3480_18884",
    x1: 164.922,
    y1: 183.389,
    x2: 25.0761,
    y2: 1.47569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EBCF6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow1);
export default __webpack_public_path__ + "static/media/arrow1.95d2cf590d41b1e21cdabfc843508c01.svg";
export { ForwardRef as ReactComponent };